import { REFRESH_FORCE } from "./constants/constantsQueryParams";

export function getRefreshForceUrl(filters: Record<string, any> = {}): string {
	const randomStr = Math.random().toString(36).substring(2, 15);

	const params = [
		`${encodeURIComponent(REFRESH_FORCE)}=${encodeURIComponent(randomStr)}`,
		...Object.entries(filters)
			.filter(([_, value]) => value !== undefined && value !== null)
			.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`),
	].join("&");

	return params ? `?${params}` : "";
}
